
import Vue from "vue";
import { Menu } from "@ambii-com/core";
import MenuChip from "./MenuChip.vue";

export default Vue.extend({
  components: {
    MenuChip,
  },
  props: {
    menu: Menu,
    parentMenu: {
      type: Menu,
      required: false,
    },
    dark: Boolean,
    chipContainerWidth: Number,
  },
});
